import React from 'react';
import uploadFailedImage from '../../assets/upload-failed.png'; // update path as needed

const UploadFailedPopup = (props) => {
    //console.log("uploaderror",props)

    const handleClose=(e)=>{
props&&props.setUploadFailed(false)
    }
      return (
    <div style={styles.overlay}>
      <div style={styles.popup}>
        <button onClick={(e)=>{handleClose(e)}} style={styles.close}>×</button>
        <div style={{display:"flex",    justifyContent:"center"}}>
        <img
          src={uploadFailedImage}
          alt="Upload Failed"
          style={{ width: 70, height: 70, marginBottom: 20 }}
        />
        </div>
        <h3 style={styles.title}>{props&&props.uploaderror}</h3>
        <button  onClick={(e)=>{handleClose(e)}} style={styles.retry}>Try Again</button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.3)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
  },
  popup: {
    position: 'relative',
    backgroundColor: '#fff',
    padding: 30,
    borderRadius: 10,
    textAlign: 'center',
    maxWidth: "100%",
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    width: "70%"
  },
  close: {
    position: 'absolute',
    top: 10,
    right: 15,
    border: 'none',
    background: 'transparent',
    fontSize: 22,
    cursor: 'pointer'
  },
  title: {
    color: '#D93025',
    fontWeight: 600,
    fontSize: 18,
    marginBottom: 20
  },
  retry: {
    backgroundColor: '#00A86B',
    color: '#fff',
    padding: '10px 20px',
    borderRadius: 8,
    border: 'none',
    fontWeight: 600,
    cursor: 'pointer',
    width: "80%",
    textAlign: "center"
  }
};

export default UploadFailedPopup;
